<app-layout>
  <app-voltar route="listagem/motorista" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>
  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input
          type="text"
          label="Nome do motorista"
          name="NM_USUA_MTRT"
          [requiredInput]="true"
          formControlName="NM_USUA_MTRT"
          placeholder="Digite aqui"></app-input>

        <app-input
          type="text"
          label="CPF"
          name="TX_CPF_MTRT"
          formControlName="TX_CPF_MTRT"
          [requiredInput]="true"
          mask="000.000.000-00"
          placeholder="___.___.___-__"></app-input>

        <app-input
          type="text"
          label="Número da CNH"
          name="TX_CNH_MTRT"
          mask="00000000000"
          formControlName="TX_CNH_MTRT"
          [requiredInput]="true"
          placeholder="Digite aqui"></app-input>

        <app-input
          type="text"
          label="Telefone"
          name="NU_TELE_MTRT"
          formControlName="NU_TELE_MTRT"
          [requiredInput]="true"
          mask="(00) 00000-0000"
          placeholder="(__) _____-____"></app-input>

        <app-input
          type="email"
          label="Email"
          name="TX_MAIL_MTRT"
          formControlName="TX_MAIL_MTRT"
          [requiredInput]="true"
          maxLength="100"
          mask="A*"
          placeholder="exemplo@exemplo.com"></app-input>
      </div>
      <app-botao
        *ngIf="!disabledMotorista"
        type="cadastro"
        [text]="isEditing ? 'Editar Motorista' : 'Cadastrar Motorista'"
        class="botao-cadastro"
        (click)="postarDados()"
        [disabled]="!form.valid"></app-botao>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
